import { useCallback } from "react";
import { Link } from "react-router-dom";
import cn from "classnames";
import { FCX } from "@datassential/platform-ui-lib";
import { getFormattedThousand } from "@core/helpers";
import { routeNames } from "@core/routeNames";
import BarChart, { BarChartItem, BarRenderProps } from "@components/BarChart/BarChart";
import "./PeopleChart.scss";
import { isNumber } from "@core/formValidation";
import { NO_VALUE_PLACEHOLDER } from "@models";

interface PeopleChartProps {
    data: BarChartItem[];
    formatValue?: (value: number) => string;
}

const defaultFormatValue = (value: number) => isNumber(value) ? `${getFormattedThousand(value)}%` : NO_VALUE_PLACEHOLDER;

const PeopleChart: FCX<PeopleChartProps> = ({ data, formatValue = defaultFormatValue, className }) => {
    const renderBar = useCallback(
        (item: BarChartItem, index: number, barProps: BarRenderProps) => {
            const encodedName = encodeURIComponent(item.name || '');

            return (
                <Link
                    key={`bar-${item.id || index}`}
                    className={barProps.className}
                    style={barProps.style}
                    to={{
                        pathname: routeNames.food,
                        search: `?q=${encodedName}`
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <div className="BarChart__bar-value">
                        {barProps.valueLabel}
                    </div>
                </Link>
            );
        },
        []
    );

    return (
        <BarChart
            className={cn("PeopleChart", className)}
            data={data}
            formatValue={formatValue}
            renderBar={renderBar}
        />
    );
};

export default PeopleChart;
